import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RemoteRecord } from '@client/common/redux/RemoteRecord';
import { AppState } from '@client/common/redux/store';
import { fetchProductAccessories, selectProductAccessoriesBySku } from '@client/product/redux/productAccessories/redux';
import { ProductAccessoriesType } from '@client/product/redux/productAccessories/types';

export const useProductAccessoriesEffect = (
  sku: string,
): RemoteRecord<ProductAccessoriesType> => {
  const dispatch = useDispatch();
  const accessories = useSelector(
    (state: AppState) => selectProductAccessoriesBySku(state, sku),
  );

  useEffect(
    (): void => {
      if (!accessories.wasStarted) {
        dispatch(fetchProductAccessories({ sku }));
      }
    },
    [accessories.wasStarted, sku],
  );

  return accessories;
};
